import './no-result.scss'

import React from 'react'
import { GridContainer } from '@entur/grid'
import { Heading4, Paragraph } from '@entur/typography'
import { Layout4 } from '../layout/layouts'

type NoResultsProps = {
  imgSrc: string
  imageHeight: string
  text: string
  title?: string
  className?: string
}
export const NoResult: React.FC<NoResultsProps> = (props) => {
  return (
    <GridContainer className={`no-result ${props.className}`}>
      <Layout4>
        <img alt="Ingen resultater illustrasjon" src={props.imgSrc} height={props.imageHeight} />
      </Layout4>
      <Layout4>
        <Heading4> {props.title ? props.title : 'Her var det tomt!'}</Heading4>
      </Layout4>
      <Layout4>
        <Paragraph>{props.text}</Paragraph>
      </Layout4>
    </GridContainer>
  )
}
